import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

// The project search term (Pipeline and Portfolio filter rows). It is kept
// app-wide and remembered for the session: leaving for another page and
// coming back, or reloading, finds the same term in the box.
const STORAGE_KEY = 'pmoProjectSearch';

interface SearchContextValue {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const SearchContext = createContext<SearchContextValue>({ searchTerm: '', setSearchTerm: () => {} });

export function SearchProvider({ children }: { children: ReactNode }) {
  const [searchTerm, setSearchTerm] = useState(() => {
    try { return sessionStorage.getItem(STORAGE_KEY) || ''; } catch { return ''; }
  });
  useEffect(() => {
    try {
      if (searchTerm) sessionStorage.setItem(STORAGE_KEY, searchTerm);
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch { /* storage unavailable: the term still lives for this page load */ }
  }, [searchTerm]);
  return (
    <SearchContext.Provider value={{ searchTerm, setSearchTerm }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  return useContext(SearchContext);
}
